import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"realtime-histogram-setting"},[_c(VCardText,[_c('histogram-settings'),_c(VProgressLinear,{directives:[{name:"show",rawName:"v-show",value:(!_vm.$store.state.monitoring.realtime.histogram_compare.loaded),expression:"!$store.state.monitoring.realtime.histogram_compare.loaded"}],attrs:{"color":"primary","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }